// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as ConstruiraiRouteImport } from './routes/construirai'
import { Route as EmbaixadoresRouteImport } from './routes/embaixadores'
import { Route as PrivacidadeRouteImport } from './routes/privacidade'
import { Route as TermosRouteImport } from './routes/termos'
import { Route as BlogSlugRouteImport } from './routes/blog_.$slug'
import { Route as AuthenticatedAdminBlogRouteImport } from './routes/_authenticated/admin.blog'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const ConstruiraiRoute = ConstruiraiRouteImport.update({
            id: '/construirai',path: '/construirai',getParentRoute: () => rootRouteImport
          })
const EmbaixadoresRoute = EmbaixadoresRouteImport.update({
            id: '/embaixadores',path: '/embaixadores',getParentRoute: () => rootRouteImport
          })
const PrivacidadeRoute = PrivacidadeRouteImport.update({
            id: '/privacidade',path: '/privacidade',getParentRoute: () => rootRouteImport
          })
const TermosRoute = TermosRouteImport.update({
            id: '/termos',path: '/termos',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog_/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminBlogRoute = AuthenticatedAdminBlogRouteImport.update({
            id: '/admin/blog',path: '/admin/blog',getParentRoute: () => AuthenticatedRouteRoute
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminBlogRoute: AuthenticatedAdminBlogRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AuthRoute: AuthRoute,BlogRoute: BlogRoute,ConstruiraiRoute: ConstruiraiRoute,EmbaixadoresRoute: EmbaixadoresRoute,PrivacidadeRoute: PrivacidadeRoute,TermosRoute: TermosRoute,BlogSlugRoute: BlogSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)